import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
/* eslint-disable ember/no-runloop */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from "@ember/-internals/owner";
import { action } from "@ember/object";
import UpstreamTransition from "@ember/routing/transition";
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import Component from "@glimmer/component";
import FormAction from "core/components/forc/form-action";
import errors from "core/services/errors";
import { task } from "ember-concurrency";
import ApplicationAdapter from "parog-web/adapters/application";
/**
 * This is the base class of the FORC (Feature Oriented Route Component)
 */
let ForcBaseComponent = (_class = class ForcBaseComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "errors", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _defineProperty(this, "applicationAdapter", getOwner(this)?.lookup("adapter:application"));
    /// ABSTRACT PROPERTIES
    _defineProperty(this, "afterCancel", this.args.afterCancel ?? (() => {}));
    _defineProperty(this, "afterCompleted", this.args.afterCompleted ?? (() => {}));
    _defineProperty(this, "submitButtonTitle", this.args.submitButtonTitle || "Sauvegarder");
    _defineProperty(this, "cancelButtonTitle", this.args.cancelButtonTitle || "Fermer");
    _defineProperty(this, "forceQuit", false);
    _defineProperty(this, "onCancel", _buildTask(() => ({
      context: this,
      generator: function* () {
        yield this.afterCancel();
      }
    }), null, "onCancel", null));
    _defineProperty(this, "onSubmit", _buildTask(() => ({
      context: this,
      generator: function* (_event) {
        this.beforeValidation();
        const isValid = yield this.isValid();
        if (!isValid) {
          yield this.errors.displayError("Veuillez corriger les erreurs avant de sauvegarder !");
          return;
        }
        yield this.save();
        this.forceQuit = true;
        if (this.afterCompleted) {
          yield this.afterCompleted();
        }
      }
    }), null, "onSubmit", null));
    next(() => {
      next(() => {
        if (args.anchor) {
          const elementToScrollTo = document.getElementById(args.anchor);
          elementToScrollTo?.scrollIntoView({
            behavior: "smooth"
          });
        }
      });
    });
    // Exiting the Forc is not only done by the form buttons
    // It could also happen when the user clicks on a link in the UI.
    // The Forc must then be informed when the router will transition
    // and in turn, alert the user if there are pending changes.
    this.router.on("routeWillChange", this.showPendingChangesetAlert);
  }
  willDestroy() {
    // https://github.com/emberjs/ember.js/blob/v3.28.1/packages/%40ember/-internals/runtime/lib/mixins/evented.js#L124
    // https://api.emberjs.com/ember/3.28/classes/Evented/methods/off?anchor=off
    // https://api.emberjs.com/ember/3.28/functions/@ember%2Fobject%2Fevents/removeListener
    // https://balinterdi.com/blog/warning-about-losing-unsaved-changes-in-ember-octane/
    this.router.off("routeWillChange", this.showPendingChangesetAlert);
    super.willDestroy();
  }
  beforeValidation() {
    return;
  }
  get patient() {
    return this.args.patient;
  }

  /* Automatically provided by the controller */
  get isReadOnly() {
    return this.args.isReadOnly;
  }
  get originJournalEventType() {
    return this.args.originJournalEventType;
  }
  get originJournalEventId() {
    return this.args.originJournalEventId;
  }
  /**
   * Can be set to `false` to disable form dirtyness check to disable the submit
   * button.
   * This is especially useful when chaining forms.
   */
  get checkDirtyness() {
    return this.args.checkDirtyness !== undefined ? this.args.checkDirtyness : true;
  }
  get formAction() {
    return this.isReadOnly ? FormAction.Show : this.args.formAction || FormAction.New;
  }
  async save() {
    return;
  }
  async isValid() {
    return Promise.resolve(true);
  }
  get isDirty() {
    return true;
  }
  async showPendingChangesetAlert(transition) {
    if (!this.isDirty) return;

    // Reported here: https://github.com/emberjs/ember.js/issues/19076
    if (transition.isAborted) return;

    // This will handle the case where only the query param changes.
    // This case can happen when the Forc is displayed in a tab.
    if (transition.from?.name == transition.to?.name) return;
    if (this.forceQuit) {
      return;
    }
    transition.abort();
    const response = await this.errors.showPendingChangesetError();
    if (response.isDismissed) return;

    // The user really want to loose its modifications.
    this.forceQuit = true;
    // This code would be better, but not accessible with the current
    // architecture of the Forc: this.args.changeset.rollback();
    transition.retry();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "showPendingChangesetAlert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showPendingChangesetAlert"), _class.prototype), _class);
export { ForcBaseComponent as default };